import styled, { css } from 'styled-components';
import colors from '../../styles/colors';

const HIGHLIGHT_CLASSNAME = 'highlight';

const Wrapper = styled.div`
  padding: 0;
`;

const textStyles = css`
  font-style: normal;
  font-weight: 400;
  font-size: ${({ $isCheckoutPageview }) => ($isCheckoutPageview ? '12px' : '15px')};
  line-height: 25px;
`;

const ContractContent = styled.div`
  ${textStyles}
  color: ${colors.shades.gamma10};

  span.${HIGHLIGHT_CLASSNAME} {
    color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark4 : colors.base.beta)};
    font-weight: 500;
    display: inline-block;
    padding: 3px 6px;
    margin: 0;
    line-height: initial;
  }
`;

const AgreementContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${textStyles}
  margin-top: 20px;
  color: ${colors.shades.gamma10};
  margin-bottom: 30px;

  span {
    color: ${colors.shades.dark4};
    font-weight: 500;
    padding-left: 5px;
  }
`;

const StyledListItem = styled.li`
  color: ${colors.shades.gamma10};
  ${textStyles}
`;

const Title = styled.div`
  display: flex;
  span {
    color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark4 : colors.base.beta)};
  }
`;

const StyledContactLink = styled.a`
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark4 : colors.shades.secondary8)};
  }
`;

const StyledList = styled.ul`
  padding-left: 20px;
  margin: 0  0 20px 0;
`;

const StyledParagraph = styled.p`
  margin: 0;
`;

export {
  Wrapper,
  ContractContent,
  HIGHLIGHT_CLASSNAME,
  AgreementContainer,
  StyledListItem,
  Title,
  StyledList,
  StyledContactLink,
  StyledParagraph,
};
